export default {
  messageType: 'Commerce',
  title: 'Commerce Settings',
  label: {
    title: 'Product name',
    regularPrice: 'Regular Price',
    discountPrice: 'Discount Price',
    discountRate: 'Discount Rate',
    discountFixed: 'Fixed Discount Price',
    additionalContent: 'Additional explanation',
    imageLink: 'Image Link',
  },
  placeholder: {
    price: '0 ~ 99,999,999',
    fixed: '0 ~ 999,999',
    rate: '0 ~ 100',
    imageLink: 'Clicking the image will redirect to the registered link.',
  },
  comment: {
    image: 'Recommended: 800x600 (4:3) / Max 5MB',
    price: 'Either the discount rate or the fixed discount price must be entered.',
    rate: '※ The discount rate takes priority.',
  },
};
